import { ColumnConfig } from '../hooks/useTablePreferences';

export const questionnaireTypeColumns: ColumnConfig[] = [
  {
    key: 'title',
    label: 'Title',
    defaultWidth: 220,
    minWidth: 160,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'name',
    label: 'Name',
    defaultWidth: 160,
    minWidth: 120,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'type',
    label: 'Type',
    defaultWidth: 140,
    minWidth: 100,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'language',
    label: 'Language',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
  {
    key: 'sections',
    label: 'Sections',
    defaultWidth: 100,
    minWidth: 80,
    visible: true,
    sortable: true,
    resizable: true,
    draggable: true,
  },
];
